import { useMemo } from 'react';

import { useMediaQuery, useTheme } from '@mui/material';

export function useOfferingPageSize() {
  const theme = useTheme();

  const eight = useMediaQuery(theme.breakpoints.down('lg'));
  const twelve = useMediaQuery(theme.breakpoints.between('lg', 'xl'));

  return useMemo(() => {
    if (eight) {
      return 8;
    } else if (twelve) {
      return 12;
    } else {
      return 16;
    }
  }, [eight, twelve]);
}
